package uz.ferro.shop.pages.admin.debt

import mui.material.Dialog
import mui.material.DialogContent
import mui.material.DialogTitle
import mui.system.sx
import react.FC
import react.Props
import uz.ferro.shop.pages.admin.debt.model.CustomerDebt
import uz.ferro.shop.ui.AppTextMedium
import uz.ferro.shop.ui.HorizontalLayout
import uz.ferro.shop.ui.VerticalLayout
import uz.ferro.shop.ui.table.CellItem
import uz.ferro.shop.ui.table.HeaderItem
import uz.ferro.shop.ui.table.RowItem
import uz.ferro.shop.ui.table.TableView
import uz.ferro.shop.util.orZero
import uz.ferro.shop.util.ymd2dmy
import web.cssom.JustifyContent
import web.cssom.px

external interface DebtDetailsDialogProps : Props {
    var isOpen: Boolean
    var customerDebt: CustomerDebt
    var onClose: (() -> Unit)
}

val DebtDetailsDialog = FC<DebtDetailsDialogProps> { props ->
    Dialog {
        open = props.isOpen
        onClose = { _, _ ->
            props.onClose()
        }
        fullWidth = true
        maxWidth = "lg"
        DialogTitle {
            +props.customerDebt.businessPartnerId
        }

        DialogContent {
            VerticalLayout {
                space = 15.px
                AppTextMedium {
                    sx {
                        fontSize = 16.px
                    }
                    text = props.customerDebt.businessPartnerName
                }

                TableView {
                    positionAutoHeight = true
                    headers = listOf(
                        HeaderItem("Hujjat"),
                        HeaderItem("Raqami"),
                        HeaderItem("Yetkazilgan"),
                        HeaderItem("Muddati"),
                        HeaderItem("Miqdori")
                    )
                    items = props.customerDebt.items.map { item ->
                        RowItem(
                            key = "${item.type}_${item.documentId}",
                            cells = listOf(
                                CellItem(item.type),
                                CellItem(item.documentId.toString()),
                                CellItem(item.taxDate.ymd2dmy()),
                                CellItem(item.dueDate.ymd2dmy()),
                                CellItem((item.debit.orZero() - item.credit.orZero()).toString()),
                            )
                        )
                    }
                }

                HorizontalLayout {
                    sx {
                        justifyContent = JustifyContent.end
                    }
                    AppTextMedium {
                        sx {
                            fontSize = 18.px
                            paddingRight = 48.px
                        }
                        text = props.customerDebt.expiredAmount.toString()
                    }
                }
            }
        }
    }
}